import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { TabletRidesByDayResponse } from '@/api/routes/stat/types';

import { fetchTabletRidesByDay } from './actionCreators';

interface InitialState {
  count: number[];
  duration: number[];
  timeBegin: number | null;
  timeEnd: number | null;
  isLoading: boolean;
  error: string;
}

const initialState: InitialState = {
  count: [],
  duration: [],
  timeBegin: null,
  timeEnd: null,
  isLoading: false,
  error: '',
};

export const aggrTabletRidesByDaySlice = createSlice({
  name: 'aggrTabletRidesByDay',
  initialState,
  reducers: {
    selectTabletRidesTime: (state, action: PayloadAction<{
      timeBegin: number;
      timeEnd: number;
    }>) => {
      state.timeBegin = action.payload.timeBegin;
      state.timeEnd = action.payload.timeEnd;
    },
  },
  extraReducers: {
    [fetchTabletRidesByDay.fulfilled.type]: (state, action: PayloadAction<TabletRidesByDayResponse>) => {
      state.isLoading = false;
      state.error = '';
      state.count = action.payload.count;
      state.duration = action.payload.duration;
    },
    [fetchTabletRidesByDay.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchTabletRidesByDay.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { selectTabletRidesTime } = aggrTabletRidesByDaySlice.actions;
export default aggrTabletRidesByDaySlice.reducer;
